import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-huifu",
  "use": "icon-huifu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-huifu\"><defs><style></style></defs><path d=\"M327.91 860.41a24.46 24.46 0 0 1-8.69-1.59 24.74 24.74 0 0 1-15.82-23V687H123.61V168H899v519H493.93L346.32 852.23a24.74 24.74 0 0 1-18.41 8.18zM171.61 639H351.4v135.5L472.45 639H851V216H171.61z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol